import { render, staticRenderFns } from "./ScheduledSMSTable.vue?vue&type=template&id=1f6daf9d"
import script from "./ScheduledSMSTable.vue?vue&type=script&lang=js"
export * from "./ScheduledSMSTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports